<template>
    <div>
        <template v-if="view == 'index'">
            <spinner v-if="loading.templates"></spinner>
            <div style="overflow:hidden;" v-else>
                <vue-good-table :columns="columns"
                                :rows="rows"
                                :pagination-options="{'enabled': true}"
                >
                    <div slot="emptystate">
                        No templates available.
                    </div>
                    <template slot="table-row" slot-scope="props">
                        <div v-if="props.column.field =='name'" class="highlight">
                            <div class="warning"></div>
                            {{ props.row.name }}
                        </div>
                        <span v-else-if="props.column.field =='type'" class="capitalize">{{ props.row.type }}</span>
                        <span v-else-if="props.column.field == 'publish'"><span class="label label-sm"
                                                                                :class="[props.row.publish == 'Published' ? 'label-warning' : 'label-danger']"> {{ props.row.publish }} </span></span>
                        <template v-else-if="props.column.field =='actions'">

                            <div class="last-dropdown">
                                <actions-menu>
                                  <actions-menu-item
                                    title="Edit"
                                    icon="fa-edit"
                                    @click="switchToEditTemplate(props.row.id)"
                                  />
                                  <actions-menu-item
                                    title="Duplicate"
                                    icon="fa-copy"
                                    @click="duplicateTemplate(props.row.id)"
                                  />
                                  <actions-menu-item
                                    title="Delete"
                                    icon="fa-trash"
                                    @click="removeTemplate(props.row.id)"
                                  />
                                </actions-menu>
                            </div>

                        </template>
                        <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                    </template>
                </vue-good-table>

                <button class="btn green margin-top-10 pull-right" @click="switchToEditTemplate(null)">Create New Template</button>
                <div class="">&nbsp;</div>
            </div>
        </template>
        <template v-else-if="view == 'editTemplate'">
            <edit-template :templateId="editTemplateId" @back="switchToIndex"></edit-template>
        </template>

        <duplicate-template-modal
                :duplicate-template-id="duplicateTemplateId"
                v-if="showDuplicateTemplateModal"
                v-on:hide="showDuplicateTemplateModal = false"
                v-on:duplicate-success="templateDuplicated"
        ></duplicate-template-modal>

        <delete-template-modal
                :delete-template-id="deleteTemplateId"
                v-if="showDeleteTemplateModal"
                v-on:hide="showDeleteTemplateModal = false"
                v-on:delete-success="templateDeleted"
        ></delete-template-modal>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from "vuex";
    import Spinner from "@/components/Spinner";
    import DuplicateTemplateModal from "@/components/emails/DuplicateTemplateModal";
    import EditTemplate from "./EditTemplate";
    import DeleteTemplateModal from "./DeleteTemplateModal";
    import ActionsMenu from "../reusables/ActionsMenu";
    import ActionsMenuItem from "../reusables/ActionsMenuItem";

    export default {

        components: {
            DeleteTemplateModal,
            Spinner,
            DuplicateTemplateModal,
            EditTemplate,
            ActionsMenu,
            ActionsMenuItem
        },
        data() {
            return {
                view: 'index',
                columns: [
                    {
                        label: 'Template name',
                        field: 'name',
                        filterOptions: {enabled: true}
                    },
                    {
                        label: 'Subject',
                        field: 'subject',
                        filterOptions: {enabled: true}
                    },
                    {
                        label: 'Created By',
                        field: 'created_by',
                        filterOptions: {enabled: true}
                    },
                    {
                        label: 'Last Modified',
                        field: 'modified_by',
                        filterOptions: {enabled: true}
                    },
                    {
                        label: 'Actions',
                        field: 'actions',
                        sortable: false
                    }
                ],
                showDuplicateTemplateModal: false,
                showDeleteTemplateModal: false,
                duplicateTemplateId: null,
                deleteTemplateId: null,
                editTemplateId: null,
            }
        },

        computed: {
            ...mapGetters({
                templates: 'emails/getTemplates',
                loading: 'emails/getLoading'
            }),

            rows() {
                let rows = [];
                Object.entries(this.templates).forEach(([key, row]) => {
                    let date = this.$options.filters.formatDate(row.created_at.date);

                    if(row.created_by) {
                        row.created_by = row.created_by + ' on ' + date;
                    }

                    if (row.modified_at) {
                        date = this.$options.filters.formatDate(row.modified_at.date);
                    }

                    if (row.modified_by) {
                        row.modified_by = row.modified_by + ' on ' + date;
                    }

                    rows.push(row);
                });
                return rows;
            }
        },

        mounted() {
            this.fetchTemplates();
        },

        methods: {
            ...mapActions('emails', [
                'fetchTemplates'
            ]),

            duplicateTemplate(templateId) {
                this.duplicateTemplateId = templateId;
                this.showDuplicateTemplateModal = true;
            },

            removeTemplate(templateId) {
                this.deleteTemplateId = templateId;
                this.showDeleteTemplateModal = true;
            },

            switchToEditTemplate(templateId) {
                this.editTemplateId = templateId;
                this.view = 'editTemplate';
            },

            switchToIndex() {
                this.fetchTemplates();
                this.view = 'index';
            },

            templateDeleted(){
                this.fetchTemplates();
            },

            templateDuplicated() {
                this.fetchTemplates();
            },

            dateSortFn(x, y, col, rowX, rowY) {
                let xDate = moment(x).unix();
                let yDate = moment(y).unix();
                return (xDate < yDate ? -1 : (xDate > yDate ? 1 : 0));
            },

            statusSortFn(x, y, col, rowX, rowY) {
                return (x < y ? -1 : (x > y ? 1 : 0));
            }
        },

        inject: {
            $validator: '$validator'
        },
    }
</script>

<style scoped>
    .last-dropdown {
        width: auto;
    }

    .dropdown-menu {
        left: -110px;
    }

    .dropdown > .dropdown-menu:before, .dropdown-toggle > .dropdown-menu:before, .btn-group > .dropdown-menu:before {
        left: 140px;
    }

    .btn-group > .dropdown-menu:after {
        left: 141px;
    }
</style>



// WEBPACK FOOTER //
// TemplatesIndex.vue?240bf598